import { FC } from 'react';
import { IconProps } from '../../../ts/interfaces/components';
import classNames from 'classnames/bind';
import styles from './flag.module.css';

const cx = classNames.bind(styles);

export const ItalyFlag: FC<IconProps> = ({ width, height, className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      id='flag-icons-it'
      viewBox='0 0 640 480'
      width={width}
      height={height}
      className={cx('flag', className)}
    >
      <path fill='#009246' d='M0 0h213.3v480H0z' />
      <path fill='#fff' d='M213.3 0h213.4v480H213.3z' />
      <path fill='#ce2b37' d='M426.7 0H640v480H426.7z' />
    </svg>
  );
};
